import requestCommon from "@/components/web-interface/requestCommon";
const state = {
  salesData: null,
};
const actions = {
  getSalesData(context, data) {
    return requestCommon.getInfo(
      "/sales/" + data.type,
      null,
      null,
      context,
      "getSalesDataSuccessHandler",
      "getSalesDataErrorHandler"
    );
  },
}
const mutations = {
  getSalesDataSuccessHandler(state, data) {
    state.salesData = data.server.data;
  },
  getSalesDataErrorHandler(context, error,) {
    console.log(error);
  },
};
const getters = {};
export const salesStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}